import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React from "react";
import { ReactComponent as DialogAlert } from "../assets/images/dialog-alert.svg";
import { ReactComponent as WarningAlert } from "../assets/images/wraning.svg";
import { ReactComponent as Trash } from "../assets/images/trash.svg";
import CloseIcon from "../assets/images/plus-circle-fill.svg";

const ConfirmDialog = (props) => {
  const { t } = useTranslation()
  const handleClose = () => {
    props.setValueClose(false)
  };
  const handleCancel = () => {
    props.setValue(false)
  };
  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="form-add-dialog-title" fontSize="1.3rem" color="#404349">
          {props.title}
          <Box sx={{ position: "absolute", right: 0, margin: "20px 18px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
          <Divider sx={{ marginTop: "10px" }} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }} component="div">
            {
              props.trash === true ? <Trash></Trash> : props.warning === true ? <WarningAlert></WarningAlert> : <DialogAlert></DialogAlert>
            }
            <Typography mt={3} fontSize={18} lineHeight="26.91px" fontWeight={500} color="#404349" sx={{ textAlign: "center" }}>{props.text}</Typography>
            {/* <Box display="flex" justifyContent="center" flexDirection="column" sx={{ width: "100%" }}> */}
            <Box display="flex" sx={{ width: "100%" }} mt="20px">
              <Typography mt="5px" ml="80px" fontSize={16} lineHeight="23.92px" fontWeight={500} color="#404349" sx={{ width: "20%", textAlign: "left", minWidth: "110px" }}>File Name: </Typography>
              <Typography mt="5px" ml="20px" fontSize={16} lineHeight="23.92px" fontWeight={400} color="#404349" sx={{ textAlign: "left" }}>{props.fileName}</Typography>
            </Box>
            <Box display="flex" sx={{ width: "100%" }}>
              <Typography mt="5px" ml="80px" fontSize={16} lineHeight="23.92px" fontWeight={500} color="#404349" sx={{ width: "20%", textAlign: "left", minWidth: "110px" }}>Template Type: </Typography>
              <Typography mt="5px" ml="20px" fontSize={16} lineHeight="23.92px" fontWeight={400} color="#404349" sx={{ textAlign: "left" }}>{props.type}</Typography>
            </Box>
            <Box display="flex" sx={{ width: "100%" }}>
              <Typography mt="5px" ml="80px" fontSize={16} lineHeight="23.92px" fontWeight={500} color="#404349" sx={{ width: "20%", textAlign: "left", minWidth: "110px" }}>Cycle: </Typography>
              <Typography mt="5px" ml="20px" fontSize={16} lineHeight="23.92px" fontWeight={400} color="#404349" sx={{ textAlign: "left" }}>{props.cycle}</Typography>
            </Box>
            <Box display="flex" sx={{ width: "100%" }}>
              <Typography mt="5px" ml="80px" fontSize={16} lineHeight="23.92px" fontWeight={500} color="#404349" sx={{ width: "20%", textAlign: "left", minWidth: "110px" }}>Total row: </Typography>
              <Typography mt="5px" ml="20px" fontSize={16} lineHeight="23.92px" fontWeight={400} color="#404349" sx={{ textAlign: "left" }}>{props.total}</Typography>
            </Box>
            {/* </Box> */}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <Button onClick={handleCancel} size="medium" variant="outlined" sx={{ minWidth: '150px', marginRight: "10px", textTransform: "none" }} color="black">{props.submit === true ? t("label.cancel") : t("label.notSure")}</Button>
          <Button onClick={() => props.doConfirm()} size="medium" variant="contained" sx={{ minWidth: '150px', textTransform: "none" }} color={props.warning === true ? "warning" : "red"}>{props.submit === true ? t("label.confirm") : t("label.ofCourse")}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default ConfirmDialog;
